import type { IWorkTitleSummary } from "containers/Works/types";

const STACK_MAX = 3;

type StackLayer = {
    key: string;
    initial: string;
    coverUrl?: string;
    position: "back" | "mid" | "front";
};

const layerAt = (title: IWorkTitleSummary | undefined, workName: string, fallbackKey: string) => ({
    key: title ? `title-${title.id}` : fallbackKey,
    initial: (title?.name || workName).trim().charAt(0).toUpperCase() || "?",
    coverUrl: title?.avatarUrl?.trim() || undefined,
});

export const buildStackLayers = (titles: IWorkTitleSummary[], workName: string): StackLayer[] => {
    const visible = titles.slice(0, STACK_MAX);
    const stackCount = Math.max(visible.length, 2);
    const layers: StackLayer[] = [];
    if (stackCount >= 3) layers.push({ ...layerAt(visible[2], workName, "placeholder-2"), position: "back" });
    if (stackCount >= 2) layers.push({ ...layerAt(visible[1], workName, "placeholder-1"), position: "mid" });
    layers.push({ ...layerAt(visible[0], workName, "placeholder-0"), position: "front" });
    return layers;
};

type CoveredTitlesStackProps = {
    titles: IWorkTitleSummary[];
    workName: string;
};

const CoveredTitlesStack = ({ titles, workName }: CoveredTitlesStackProps) => (
    <div className="covered-titles-stack" aria-hidden>
        {buildStackLayers(titles, workName).map((layer) => (
            <div
                key={layer.key}
                className={
                    layer.position === "front"
                        ? "covered-titles-stack__cover"
                        : `covered-titles-stack__layer covered-titles-stack__layer--${layer.position}`
                }
            >
                {layer.coverUrl ? (
                    <img className="covered-titles-stack__image" src={layer.coverUrl} alt="" />
                ) : (
                    layer.initial
                )}
            </div>
        ))}
    </div>
);

export default CoveredTitlesStack;
